import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useElementForkRef } from '@cian/react-utils';
import { Popper } from '../../../internal/components/Popper';
import { SAME_WIDTH, FLIP } from '../../../internal/components/Popper/modifiers';
/**
 * Компонента для открытия выпадающего контента с привязкой к элементу по типу Dropdown
 *
 * Умеет открываться вверх, если снизу недостаточно места
 */
export function DropdownPopover(props) {
  var open = props.open,
    content = props.content,
    sameWidth = props.sameWidth,
    flip = props.flip;
  var _useElementForkRef = useElementForkRef(props.children),
    _useElementForkRef2 = _slicedToArray(_useElementForkRef, 2),
    refferedChildren = _useElementForkRef2[0],
    childrenRef = _useElementForkRef2[1];
  var modifiers = React.useMemo(function () {
    return [sameWidth && _objectSpread(_objectSpread({}, SAME_WIDTH), {}, {
      options: _objectSpread(_objectSpread({}, SAME_WIDTH.options), {}, {
        property: sameWidth
      })
    }), flip && FLIP].filter(Boolean);
  }, [sameWidth, flip]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, refferedChildren, /*#__PURE__*/React.createElement(Popper, {
    open: open,
    anchorRef: childrenRef,
    placement: "bottom-start",
    modifiers: modifiers
  }, content));
}
DropdownPopover.defaultProps = {
  sameWidth: 'minWidth',
  flip: true
};